import { FC } from 'react';
import { Navigate } from 'react-router-dom';
import { useService } from '@hooks';
import { electrificationWizardService } from '@services';
import { LoadingLayout } from '@components/common';

export const WizardLanding: FC = () => {
	const { loading } = useService(() => electrificationWizardService.getLatest());

	if (loading) {
		return <LoadingLayout />;
	}

	return <Navigate to="../start" />;
	// if (error || !latest) {
	// 	return <Navigate to="../start" />;
	// } else {
	// 	if ([ElectrificationStatus.COMPLETED, ElectrificationStatus.ERROR].includes(latest.status)) {
	// 		return <Navigate to="../result" />;
	// 	} else {
	// 		return <Navigate to="../processing" />;
	// 	}
	// }
};
